import * as dayjs from 'dayjs';

export function isOpen(dates, exceptions) {
  let isOpen = false;

  const days = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7,
  };

  dates.forEach((date) => {
    if (date.endDay) {
      let count;
      if (days[date.startDay] > days[date.endDay]) {
        count = days[date.endDay] + 7 - days[date.startDay] + 1;
      } else {
        count = days[date.endDay] - days[date.startDay] + 1;
      }
     
      for (let i = 0; i < count; i++) {
        let day;
        if (days[date.startDay] + i > 7) {

          day = days[date.startDay] + i - 7;
        } else {
          day = days[date.startDay] + i;
        }

        if (checkDay(day)) {
          if (checkTime(parseInt(pad(date.startTime.replace(':', '')), 10), parseInt(pad(date.endTime.replace(':', '')), 10))) {
            isOpen = true;
          }
        }
      }
    } else {
      if (checkDay(days[date.startDay])) {
        if (checkTime(parseInt(pad(date.startTime.replace(':', '')), 10), parseInt(pad(date.endTime.replace(':', '')), 10))) {
          isOpen = true;
        }
      }
    }
  });

  exceptions.forEach((dateRange) => {
    if (dateRange.endDate) {
      for (let d = new Date(dateRange.startDate); d <= new Date(dateRange.endDate); d.setDate(d.getDate() + 1)) {
        if (sameDay(d, new Date())) isOpen = false;
      }
    } else {
      if (sameDay(new Date(dateRange.startDate), new Date())) isOpen = false;
    }
  });

  return isOpen;

  function checkDay(day) {
    if (new Date().getDay() === day) {
      return true;
    } else {
      return false;
    }
  }

  function checkTime(start, end) {
    const current = parseInt(`${pad(new Date().getHours())}${pad(new Date().getMinutes())}`, 10);
    if (current >= start && current <= end) return true;
  }

  function sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }

  function pad(value) {
    if (value < 10) {
      return '0' + value;
    } else {
      return value;
    }
  }
}

export function convertDay(day) {
  switch (day) {
    case 'monday':
      return 'Mon';
    case 'tuesday':
      return 'Tue';
    case 'wednesday':
      return 'Wed';
    case 'thursday':
      return 'Thu';
    case 'friday':
      return 'Fri';
    case 'saturday':
      return 'Sat';
    case 'sunday':
      return 'Sun';
    default:
      return '';
  }
}

export function formatTimes(startTime, endTime) {
  function parseTime(value) {
    const match = typeof value === 'string' && value.match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return null;
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours > 23 || minutes > 59) return null;
    return {text: `${hours % 12 || 12}${minutes ? `:${match[2]}` : ''}`, period: hours < 12 ? 'am' : 'pm'};
  }

  const start = parseTime(startTime);
  const end = parseTime(endTime);
  if (!start && !end) return '';
  if (!end) return `${start.text}${start.period}`;
  if (!start) return `${end.text}${end.period}`;
  return `${start.text}${start.period === end.period ? '' : start.period}–${end.text}${end.period}`;
}

export function formatProgramTimes(program) {
  const text = program.timesText?.trim();
  if (text) return [text];
  return (program.times || []).map(time => {
    const days = [convertDay(time.startDay), convertDay(time.endDay)].filter(Boolean).join('–');
    return [days, formatTimes(time.startTime, time.endTime)].filter(Boolean).join(' ');
  }).filter(Boolean);
}

export function formatDates(startDate, endDate) {
  let dateString = '';

  startDate = dayjs(startDate);

  if (!endDate) {
    dateString = startDate.format('D MMMM YYYY');
  } else {
    endDate = dayjs(endDate);

    if (startDate.year() === endDate.year()) {
      if (startDate.month() === endDate.month()) {
        dateString = `${startDate.format('D')}–${endDate.format('D MMMM YYYY')}`;
      } else {
        dateString = `${startDate.format('D MMMM')}–${endDate.format('D MMMM YYYY')}`;
      }
    } else {
      dateString = `${startDate.format('D MMMM YYYY')}–${endDate.format('D MMMM YYYY')}`;
    }
  }
  
  return dateString;
}
